import axios from 'axios'
import * as Sentry from "@sentry/vue"
import gtmService from '../../services/gtm'

const auth = {
  namespaced: true,

  state: {
    user: null,
    totalPoints: 0,
    loadingTotalPoints: false,
    twoFactorAuthenticationEnabled: false,
    redirectUrl: null,
  },

  mutations: {
    setUser(state, { user, fromLogin = false }) {
      state.user = user

      if (fromLogin || (EasyEvent.fromAutologin && user)) {
        gtmService.sendLogin(user && user.code)
      } else {
        gtmService.setUser(user && user.code)
      }
      // only the id: no names, e-mail or profile data to a third party (see plugins/sentry.js)
      Sentry.setUser(user && user.id ? { id: String(user.id) } : null);
    },

    setTotalPointsLoading(state, loading) {
      state.loadingTotalPoints = loading
    },

    setTotalPoints(state, points) {
      state.totalPoints = points
    },

    setTwoFactorAuthenticationEnabled(state, enabled) {
      state.twoFactorAuthenticationEnabled = enabled
    },

    setRedirectUrl(state, url) {
      state.redirectUrl = url
    },

    async changeVisitType(state, visit_type) {
      await axios.put('profile/visit-type', { visit_type })
      location.reload()
    }
  },

  actions: {
    async getVisitor({ commit }) {
      await axios.get('/auth')
        .then(response => {
          const visitor = response.data
          commit('setUser', { user: visitor || null })
        })
    },

    getTotalPoints({ commit }) {
      commit('setTotalPointsLoading', true)
      axios.get('/profile/total-points')
        .then(response => {
          commit('setTotalPoints', response.data)
          commit('setTotalPointsLoading', false)
        })
    }
  }
}

export default auth
